import { render, staticRenderFns } from "./help_view.vue?vue&type=template&id=01ba1412&scoped=true&"
import script from "./help_view.vue?vue&type=script&lang=js&"
export * from "./help_view.vue?vue&type=script&lang=js&"
import style0 from "./help_view.vue?vue&type=style&index=0&id=01ba1412&lang=scss&scoped=scoped&"
import style1 from "./help_view.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba1412",
  null
  
)

export default component.exports